import fixDate from '@/helpers/date/fixDate.js'
import { useI18n } from 'vue-i18n'

/**
 * @param {Date | string} date - The date to calculate the human-readable text for
 * @returns {string} - The date, formatted to the user's preference
 */
export default function dateVisualForClient(date) {
	if (!date) { throw new ReferenceError('date is not set') }

	const dateValue = fixDate(date)
	const i18n = useI18n()

	return new Intl.DateTimeFormat(i18n.locale.value, { year: 'numeric', month: 'long', day: 'numeric' }).format(dateValue)
}
